<template>
  <div class="pre">
    <img :src="cdnresources + '/prod/images/xiangaibao/gongs.png'" />
  </div>
</template>
<script>
  import { cdnresources } from '@/util/config'
  export default {
    data() {
      return {
        cdnresources
      }
    }
  }
</script>
<style lang="scss" scoped>
  .pre {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: xvw(30);
    line-height: xvw(42);
    color: #999999;
    margin: xvw(10) auto;
    img {
      width: 100%;
    }
  }
</style>
